export enum WidgetSettingsAction {
    OPEN_WIDGET_SETTINGS = 'OPEN_WIDGET_SETTINGS',
    DETACH_WIDGET = 'DETACH_WIDGET'
}
